import gql from 'graphql-tag';

export const ContentSmartLinksQueryForDraft = gql`
	query confluence_contentSmartLinksForDraft($contentId: ID!) {
		confluence_contentSmartLinksForDraft(id: $contentId) {
			nodes {
				__typename
				url
			}
		}
	}
`;
